// libraries
import React from "react";

// components
// import Content from "src/components/Error/Content/Content";
import { NotFound } from "src/content";

const Error = () => {
  return <NotFound />;
};

export default Error;
